const NOMINATIM_API_URL = 'https://nominatim.openstreetmap.org';

const SUGGESTIONS_LIMIT = 5;

export interface GeocodingResult {
  displayName: string;
  lat: number;
  lon: number;
  boundingBox: [number, number, number, number]; // [south, north, west, east]
}

interface NominatimSearchResult {
  display_name: string;
  lat: string;
  lon: string;
  boundingbox: [string, string, string, string];
}

// Un boundingbox Nominatim malformé (longueur inattendue, valeur non
// numérique) ne doit pas se propager en NaN/undefined jusqu'à fitBounds
// (MapPage.tsx) : le résultat est écarté plutôt que de casser la carte.
const parseBoundingBox = (raw: unknown): [number, number, number, number] | null => {
  if (!Array.isArray(raw) || raw.length !== 4) return null;
  const parsed = raw.map(Number);
  return parsed.every(Number.isFinite)
    ? (parsed as [number, number, number, number])
    : null;
};

const toGeocodingResult = (result: NominatimSearchResult): GeocodingResult | null => {
  const boundingBox = parseBoundingBox(result.boundingbox);
  if (!boundingBox) {
    console.error("Réponse Nominatim ignorée : boundingbox invalide", result);
    return null;
  }
  return {
    displayName: result.display_name,
    lat: parseFloat(result.lat),
    lon: parseFloat(result.lon),
    boundingBox,
  };
};

export class GeocodingService {
  /**
   * Appelle directement l'API de géocodage Nominatim depuis le navigateur,
   * à l'image de FlashInvadersService, sans passer par le backend.
   */
  static async search(query: string): Promise<GeocodingResult[]> {
    const params = new URLSearchParams({
      q: query,
      format: 'jsonv2',
      addressdetails: '0',
      limit: String(SUGGESTIONS_LIMIT),
      'accept-language': 'fr',
    });

    const response = await fetch(`${NOMINATIM_API_URL}/search?${params}`);

    if (!response.ok) {
      throw new Error(`Erreur du service de géocodage : ${response.status}`);
    }

    const results: NominatimSearchResult[] = await response.json();
    return results
      .map(toGeocodingResult)
      .filter((result): result is GeocodingResult => result !== null);
  }
}
